import { useMemo } from "react";

import { BulkStatusScope, getBulkStatusScope } from "../utils/getBulkStatusScope";

type BulkStatusScopeInput = Parameters<typeof getBulkStatusScope>[0];

/**
 * The scope every select-all request of the list table carries, memoised on its inputs. A
 * select-all sends the loaded page's ids only, and the API re-derives the rest from this scope, so
 * it holds every dimension the table fetched its rows with (see `getBulkStatusScope`).
 */
export const useBulkStatusScope = ({
	selectType,
	filter,
	inclusionStatus,
	exclusionReasons,
	priorityFilterStatus,
	signalFilterStatus,
	searchValue,
	assignStatus,
}: BulkStatusScopeInput): BulkStatusScope =>
	useMemo(
		() =>
			getBulkStatusScope({
				selectType,
				filter,
				inclusionStatus,
				exclusionReasons,
				priorityFilterStatus,
				signalFilterStatus,
				searchValue,
				assignStatus,
			}),
		[
			selectType,
			filter,
			inclusionStatus,
			exclusionReasons,
			priorityFilterStatus,
			signalFilterStatus,
			searchValue,
			assignStatus,
		]
	);
